export class MyKadData {
    // Core fields (all card types) 
    // Full display name. Used as the sentinel field in loadMyKadData.
    Name: string = "";
    ICNo: string = "";
    BirthDate: string = "";
    Gender: string = "";
    Race: string = "";
    Religion: string = "";
    Address1: string = "";
    Address2: string = "";
    Address3: string = "";
    City: string = "";
    State: string = "";
    Postcode: string = "";
    PhotoBase64: string = "";
    BirthPlace: string = "";
    Nationality: string = "";
    OldICNo: string = "";
    CardType: string = "";

    // Extended fields (Thai national ID card and future card types) 
    ExpiryDate?: string = "";
    SubDistrict?: string = "";
    PrefixEn?: string = "";
    PrefixTh?: string = "";
    FirstNameEn?: string = "";
    LastNameEn?: string = "";
    FirstNameTh?: string = "";
    LastNameTh?: string = "";
}
